import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('admin@greenback.it');
  const [password, setPassword] = useState('demo1234');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      navigate('/overview');
    }, 800);
  };
  const handleSSOLogin = (provider: 'google' | 'microsoft') => {
    setIsLoading(true);
    setTimeout(() => {
      navigate('/overview');
    }, 800);
  };
  return <div className="min-h-screen bg-green-600 flex items-center justify-center p-4" data-id="element-3079">
      <div className="w-full max-w-md" data-id="element-3080">
        {/* Logo and Title */}
        <div className="text-center mb-8" data-id="element-3081">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-2xl shadow-lg mb-4" data-id="element-3082">
            <img src="https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png" alt="Greenback" className="h-10 w-10" data-id="element-3083" />
          </div>
          <h1 className="text-3xl font-semibold text-white mb-2" data-id="element-3084">Greenback</h1>
          <p className="text-green-100 text-sm font-normal" data-id="element-3085">Admin Dashboard</p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200" data-id="element-3086">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-3087">
            Accesso Admin
          </h2>
          <p className="text-sm font-normal text-gray-500 mb-6" data-id="element-3088">
            Accedi alla dashboard amministrativa
          </p>

          <form onSubmit={handleLogin} className="space-y-4" data-id="element-3089">
            {/* Email Input */}
            <div data-id="element-3090">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3091">
                Email
              </label>
              <div className="relative" data-id="element-3092">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-3093" />
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-gray-300 text-sm font-normal focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent" style={{
                borderRadius: '100px'
              }} placeholder="admin@example.com" required data-id="element-3094" />
              </div>
            </div>

            {/* Password Input */}
            <div data-id="element-3095">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3096">
                Password
              </label>
              <div className="relative" data-id="element-3097">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-3098" />
                <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-12 py-2.5 border border-gray-300 text-sm font-normal focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent" style={{
                borderRadius: '100px'
              }} placeholder="••••••••" required data-id="element-3099" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600" data-id="element-3100">
                  {showPassword ? <EyeOff className="h-5 w-5" data-id="element-3101" /> : <Eye className="h-5 w-5" data-id="element-3102" />}
                </button>
              </div>
            </div>

            {/* Remember Me & Forgot Password */}
            <div className="flex items-center justify-between text-sm" data-id="element-3103">
              <label className="flex items-center" data-id="element-3104">
                <input type="checkbox" className="h-4 w-4 text-green-600 border-gray-300 rounded focus:ring-green-600" defaultChecked data-id="element-3105" />
                <span className="ml-2 text-sm font-normal text-gray-600" data-id="element-3106">
                  Ricordami
                </span>
              </label>
              <a href="#" className="text-sm font-medium text-green-600 hover:text-green-700" data-id="element-3107">
                Password dimenticata?
              </a>
            </div>

            {/* Login Button */}
            <button type="submit" disabled={isLoading} className="w-full bg-green-600 text-white py-2.5 text-sm font-medium hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
            borderRadius: '100px'
          }} data-id="element-3108">
              {isLoading ? 'Accesso in corso...' : 'Accedi'}
            </button>
          </form>

          {/* Divider */}
          <div className="relative my-6" data-id="element-3109">
            <div className="absolute inset-0 flex items-center" data-id="element-3110">
              <div className="w-full border-t border-gray-200" data-id="element-3111"></div>
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-3112">
              <span className="px-4 bg-white text-sm font-normal text-gray-500" data-id="element-3113">
                Oppure accedi con
              </span>
            </div>
          </div>

          {/* SSO Buttons */}
          <div className="space-y-3" data-id="element-3114">
            <button type="button" onClick={() => handleSSOLogin('google')} disabled={isLoading} className="w-full flex items-center justify-center gap-3 px-4 py-2.5 border border-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
            borderRadius: '100px'
          }} data-id="element-3115">
              <svg className="h-5 w-5" viewBox="0 0 24 24" data-id="element-3116">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-3117" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-3118" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-3119" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-3120" />
              </svg>
              <span className="text-sm font-medium text-gray-700" data-id="element-3121">
                Google Workspace
              </span>
            </button>

            <button type="button" onClick={() => handleSSOLogin('microsoft')} disabled={isLoading} className="w-full flex items-center justify-center gap-3 px-4 py-2.5 border border-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
            borderRadius: '100px'
          }} data-id="element-3122">
              <svg className="h-5 w-5" viewBox="0 0 23 23" data-id="element-3123">
                <path fill="#f3f3f3" d="M0 0h23v23H0z" data-id="element-3124" />
                <path fill="#f35325" d="M1 1h10v10H1z" data-id="element-3125" />
                <path fill="#81bc06" d="M12 1h10v10H12z" data-id="element-3126" />
                <path fill="#05a6f0" d="M1 12h10v10H1z" data-id="element-3127" />
                <path fill="#ffba08" d="M12 12h10v10H12z" data-id="element-3128" />
              </svg>
              <span className="text-sm font-medium text-gray-700" data-id="element-3129">
                Microsoft 365
              </span>
            </button>
          </div>

          {/* Help Text */}
          <p className="mt-6 text-center text-xs font-normal text-gray-500" data-id="element-3130">
            Non hai un account?{' '}
            <a href="#" className="text-green-600 hover:text-green-700 font-medium" data-id="element-3131">
              Contatta il supporto
            </a>
          </p>
        </div>

        {/* Footer */}
        <p className="mt-8 text-center text-xs font-normal text-green-100" data-id="element-3132">
          © 2026 Greenback. Tutti i diritti riservati.
        </p>
      </div>
    </div>;
};
export default Login;